/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CloudConnection
 */
export interface CloudConnection {
    /**
     * 
     * @type {number}
     * @memberof CloudConnection
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof CloudConnection
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CloudConnection
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof CloudConnection
     */
    readonly presignedLoginUrl: string;
}

export function CloudConnectionFromJSON(json: any): CloudConnection {
    return CloudConnectionFromJSONTyped(json, false);
}

export function CloudConnectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): CloudConnection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'url': json['url'],
        'presignedLoginUrl': json['presigned_login_url'],
    };
}

export function CloudConnectionToJSON(value?: CloudConnection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'url': value.url,
    };
}


